import useNavigation from "@/utils/useNavigate";
import { ProductListItemModel } from "@akc/biz-api";
import { ProductCard11Comp } from "@akc/mx-taro-h5-components";
import React, { useCallback, useMemo } from "react";
import styles from "./BrandModule.module.less";

interface BrandModuleProps {
  moduleInfo?: {
    moduleId: string;
    moduleName: string;
    moduleDesc: string;
    productList?: any[];
  };
  currentRole?: string;
  control?: any;
  handleShareProduct?: (product: ProductListItemModel) => void;
}

const BrandModule: React.FC<BrandModuleProps> = prop => {
  const { navigate2Product, nav2RmsMaterialList } = useNavigation();
  const { moduleInfo, currentRole, control, handleShareProduct } = prop;

  const goToProductDetail = useCallback(
    (product: ProductListItemModel) => {
      navigate2Product({
        activityId: product.activityId,
        activitySpuId: product.activitySpuId ?? "",
        selectSkuId: product.selectSkuId,
      });
    },
    [navigate2Product],
  );

  const getButtonConfig = useCallback(
    (product: ProductListItemModel) => {
      let res: any = {};
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { material_num } = product;
      if (material_num > 0 && currentRole !== "C") {
        res = {
          ...res,
          left4RE: {
            type: "forward",
            onAction: (prod: ProductListItemModel) => {
              handleShareProduct && handleShareProduct(prod);
            },
          },
          right4RE: {
            title: "查看素材",
            onAction: (prod: ProductListItemModel) => {
              nav2RmsMaterialList(prod);
            },
          },
        };
      }
      return res;
    },
    [handleShareProduct, nav2RmsMaterialList, currentRole],
  );

  const cardCallbacks = useMemo(() => {
    return {
      onSkusClick: (product: ProductListItemModel) => {
        // sku切换
        goToProductDetail(product);
      },
      onBuyClick: (product: ProductListItemModel) => {
        //点击「立即购买」
        goToProductDetail(product);
      },
      onProdutClick: (product: ProductListItemModel) => {
        //点击「商品卡片」
        goToProductDetail(product);
      },
      onAddCartClick: (product: ProductListItemModel) => {
        // 加购
        goToProductDetail(product);
      },
      onItemClick: (product: ProductListItemModel) => {
        //点击「商品卡片」
        goToProductDetail(product);
      },
      onForwardClick: (product: ProductListItemModel) => {
        //点击「分享」
        handleShareProduct && handleShareProduct(product);
      },
    };
  }, [goToProductDetail, handleShareProduct]);

  if (!moduleInfo?.productList?.length) {
    return null;
  }

  return (
    <div className={styles.BrandModule}>
      <div className={styles.BrandModuleTitle}>
        <div className={styles.moduleName}>{moduleInfo?.moduleName}</div>
        <div className={styles.moduleDesc}>{moduleInfo?.moduleDesc}</div>
      </div>
      <div className={styles.BrandModuleContent}>
        {moduleInfo?.productList?.map((item, index) => (
          <ProductCard11Comp
            key={index}
            className={styles.ProductCard11Comp}
            product={item}
            priceInfo={item?.skuAdvancePriceInfo || item?.skuCurrentPriceInfo}
            titleBottomLocationCode="H5_ProductDetail_Material_ProductTitleDown"
            isShowAddCart={false}
            buttonConfig={getButtonConfig(item)}
            onSkusClick={cardCallbacks.onSkusClick}
            onBuyClick={cardCallbacks.onBuyClick}
            onProdutClick={cardCallbacks.onProdutClick}
            onAddCartClick={cardCallbacks.onAddCartClick}
            onItemClick={cardCallbacks.onItemClick}
            onForwardClick={cardCallbacks.onForwardClick}
            rankIndex={index + 1}
            trackData={{
              page_name: control.pageName,
              content_id: control.planId,
              previous_page_name:
                control.search.get("previous_page_name") ??
                control.search.get("page_name") ??
                control.pageName,
              resource_type: "商品卡片",
              resource_content: "商品",
              resource_name: "商品详情",
              resource_id: item?.activityId,
              activity_spu_id: item?.activitySpuId,
              activity_spu_code: item?.activitySpuId,
              select_sku_id: item?.selectSkuId,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default BrandModule;
